// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__B0kdG","header":"ReportDetails_header__2X-n1","title":"ReportDetails_title__3H_wM","left":"ReportDetails_left__3WBu8"};